// Lightweight arcade sound effects + haptics.
// Uses Web Audio API. AudioContext is created lazily after a user gesture.

let ctx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

function tone(freq, duration = 0.12, type = "square", gain = 0.05, delay = 0) {
  const ac = getCtx();
  if (!ac) return;
  const now = ac.currentTime + delay;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, now);
  g.gain.setValueAtTime(0.0001, now);
  g.gain.exponentialRampToValueAtTime(gain, now + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, now + duration);
  osc.connect(g).connect(ac.destination);
  osc.start(now);
  osc.stop(now + duration + 0.02);
}

function vibrate(pattern) {
  if (typeof navigator !== "undefined" && navigator.vibrate) {
    try {
      navigator.vibrate(pattern);
    } catch (e) {
      /* noop */
    }
  }
}

export const sfx = {
  commit() {
    tone(880, 0.08, "square");
    vibrate(20);
  },
  reveal() {
    tone(660, 0.08, "sawtooth");
    tone(990, 0.09, "square", 0.05, 0.06);
    vibrate(30);
  },
  win() {
    tone(523, 0.09, "square");
    tone(659, 0.09, "square", 0.05, 0.09);
    tone(784, 0.16, "square", 0.05, 0.19);
    vibrate([40, 30, 80]);
  },
  lose() {
    tone(300, 0.14, "sawtooth", 0.05);
    tone(180, 0.22, "sawtooth", 0.05, 0.12);
    vibrate([80]);
  },
  tie() {
    tone(440, 0.1, "triangle", 0.05);
    vibrate(20);
  },
  tick() {
    tone(1200, 0.03, "square", 0.03);
  },
  urgent() {
    tone(1400, 0.06, "square", 0.05);
    vibrate(15);
  },
  roundWin() {
    tone(880, 0.08, "square");
    tone(1320, 0.10, "square", 0.05, 0.05);
    vibrate([15, 20]);
  },
  roundLose() {
    tone(300, 0.10, "sawtooth", 0.045);
    vibrate(25);
  },
  roundTie() {
    tone(520, 0.06, "triangle", 0.035);
    tone(520, 0.06, "triangle", 0.035, 0.08);
    vibrate(15);
  },
};
